type SectionHeadingProps = {
  eyebrow: string
  title: string
  sub: string
}

export function SectionHeading({ eyebrow, title, sub }: SectionHeadingProps) {
  return <div className="section-title"><span>{eyebrow}</span><h2>{title}</h2><p>{sub}</p></div>
}
